<div class="mb-2">
  <div class="d-flex justify-content-between grid-header border-bottom border-1 font-size-16 "
    style="margin-left: 0.2rem;">
    <div class="d-flex flex-column  align-items-start text-start fix-with-20">
      <div>
        {{'GLOBAL.NOM' | translate}}
        <button (click)="sortColumn('NOM')" class="sort-btn">
          {{ currentSortColumn === 'NOM' && currentSortDirection === 'asc' ? '▲' : '▼' }}
        </button>
      </div>
    </div>

    <div class="d-flex flex-column justify-content-center align-items-start text-start fix-with">
      <div>
        {{'GLOBAL.TYPE' | translate}}
        <button (click)="sortColumn('TYPE')" class="sort-btn">
          {{ currentSortColumn === 'TYPE' && currentSortDirection === 'asc' ? '▲' : '▼' }}
        </button>
      </div>
    </div>

    @if (configeView) {
      <div
        class="d-flex justify-content-start align-items-center text-start calcul-mode fix-with">
        {{'CONFIGURATION_DONNEES.CALCUL_MODE' | translate}}
        <button (click)="sortColumn('CALCUL_MODE')" class="sort-btn">
          {{ currentSortColumn === 'CALCUL_MODE' && currentSortDirection === 'asc' ? '▲' : '▼' }}
        </button>
      </div>
    }

    @if (configeView) {
      <div class="calcul-mode unit text-start">
        {{'CONFIGURATION_DONNEES.UNITE' | translate}}
        <button (click)="sortColumn('UNIT')" class="sort-btn">
          {{ currentSortColumn === 'UNIT' && currentSortDirection === 'asc' ? '▲' : '▼' }}
        </button>
      </div>
    }

    @if (configeView) {
      <div
        class="d-flex flex-column justify-content-center align-items-start text-start fix-with-2 target-value">
        <div>{{'CONFIGURATION_DONNEES.TARGET_VALUE' | translate}}</div>
      </div>
    }

    @if (configeView) {
      <div class="d-flex justify-content-start align-items-center text-start gap-2">
        {{'CONFIGURATION_DONNEES.ACCESS' | translate}}
        <button (click)="sortColumn('ACCESS')" class="sort-btn">
          {{ currentSortColumn === 'ACCESS' && currentSortDirection === 'asc' ? '▲' : '▼' }}
        </button>
      </div>
    }

    @if (false) {
      <div
        class="d-flex flex-column justify-content-center align-items-start text-start fix-with-2 target-value">
        <div>{{'CONFIGURATION_DONNEES.DESIGN' | translate}}</div>
      </div>
    }

    @if (!configeView) {
      <div
        class="d-flex flex-column justify-content-center align-items-start text-start  target-value"
        style="width: 25%;">
        <div>{{'CONFIGURATION_DONNEES.FINAL' | translate}}</div>
      </div>
    }

    @if (configeView) {
      <div class="d-flex justify-content-start align-items-center text-start gap-3">
        {{'CONFIGURATION_DONNEES.IS_ENABLED' | translate}}
        <button (click)="sortColumn('ENABLED')" class="sort-btn">
          {{ currentSortColumn === 'ENABLED' && currentSortDirection === 'asc' ? '▲' : '▼' }}
        </button>
      </div>
    }

    <div style="width: 6%;" class="d-flex justify-content-center align-items-center">
      @if (estTir && tirId) {
        <button class="btn btn-sm" (click)="onRefresh()" [title]="'KPI.RECALCULATE_KPIS' | translate">
          <img src="assets/icon/update.png" alt="Refresh" width="20" />
        </button>
      }
    </div>
  </div>


    <div [ngClass]="configeView 
      ? 'scrollable-container' 
      : (inProjetDetail 
          ? 'scrollable-container-projet-detail' 
          : 'scrollable-container-blast'
        )"
    style="margin-left: 0.1rem;">
    @for (objet of $any(configeView ? listeObjets : donneesAnalyse); track objet; let j = $index) {
      <div
        class="container-fluid rounded border-bottom border-1 d-flex justify-content-between align-items-center"
        style="padding: 0.2rem;">
        <div class="d-flex flex-column justify-content-center align-items-start fix-with-20 font-size-16">
          <strong class="name">{{ objet.referentielDonneeAnalyse.nom}}</strong>
          <div class="descripition font-size-12">{{objet.referentielDonneeAnalyse.description | translate}}</div>
        </div>
        <div class="d-flex flex-column justify-content-start align-items-start fix-with">
          @if (objet.referentielDonneeAnalyse.type && objet.referentielDonneeAnalyse.type !== '') {
            <div >
              <div class="p-1 custom-radius type font-size-14">
                {{ objet.referentielDonneeAnalyse.type }}
              </div>
            </div>
          }
        </div>
        @if (configeView) {
          <div class="d-flex  align-items-start calcul-mode">
            {{ getNomModeSaisie(objet.modeSaisieDonneeProjet) }}
          </div>
        }
        @if (configeView) {
          <div class="calcul-mode unit">
            {{extractSymbol(objet.displayUnit) || replaceCurrencyPlaceholder(objet.referentielDonneeAnalyse.nomUniteReferentiel)}}
          </div>
        }
        @if (configeView) {
          <div
            class="d-flex flex-column justify-content-center align-items-start fix-with-2 target-value">
            <div>{{objet.valeurNominal}} {{extractSymbol(objet.displayUnit) || replaceCurrencyPlaceholder(objet.referentielDonneeAnalyse.nomUniteReferentiel)}}
            </div>
            <div class="descripition">Min: {{objet.valeurMin}} - Max: {{objet.valeurMax}}</div>
          </div>
        }
        @if (configeView) {
          <div class="d-flex justify-content-start gap-2">
            <div class="svg-wrapper">
              <img class="mr-1" src="assets/icon/access-permission.svg" />
            </div>
            <div class="descripition">
              <div>
                @switch (objet.accessPermission) {
                  @case (0) {
                    <p>Hidden</p>
                  }
                  @case (1) {
                    <p>Read</p>
                  }
                  @case (2) {
                    <p>Read-Write</p>
                  }
                  @default {
                    <p>---</p>
                  }
                }
              </div>
            </div>
          </div>
        }
        @if (!configeView ) {
          <div class="d-flex flex-column justify-content-center align-items-start target-value"
            style="width: 25%;">
            @if (objet.referentielDonneeAnalyse.typeSaisieKpi == 'InputText' || !estTir) {
              <div>
                @if (!isEditionMode[j]) {
                  <div>
                    @if (objet.finalValue && objet.finalValue !== '') {
                      <span class="font-size-16 number-spacing"
                        >{{estTir ? (objet.finalValue | number:'1.0-2':'fr') : (formatValue(objet.nodeValue) | number:'1.0-2':'fr')}}
                        {{replaceCurrencyPlaceholder(objet.referentielDonneeAnalyse.displayUnit)}}
                      </span>
                    }
                    @if (!configeView && $any(objet).sourceFinalValue !== 'SOURCE_KPI.NOT_SET' && $any(objet).autorisePourUtil) {
                      <span class="custom-radius-source font-size-14"
                        >
                        {{$any(objet).sourceFinalValue | translate}}
                      </span>
                    }
                    <button *showIfHasRole="'access_all_kpi'" (click)="onEditFinalValue(j)"
                      [ngClass]="{'d-none': !estTir }"
                      style="background: none; border: none; cursor: pointer; margin-left: 0.5rem;">
                      <img src="assets/icon/edit-pencil.svg" alt="Modifier" />
                    </button>
                  </div>
                }
                @if (isEditionMode[j] && !configeView) {
                  <div>
                    <div #inputContainer class="d-flex flex-row justify-content-start align-items-center gap-2">
                      <input type="text" class="form-control form-control-sm input-field"
                        [(ngModel)]="$any(objet).manualValue" (keyup.enter)="onValidate(j, $any(objet))"
                        placeholder="{{ replaceCurrencyPlaceholder(objet.referentielDonneeAnalyse.displayUnit) }}" />
                        <button class="btn p-0 d-flex align-items-center" style="margin-left: 0.6rem;"
                          (click)="onValidate(j,$any(objet))">
                          <img src="assets/icon/valider.svg" class="me-2" width="20" alt="confirm"/>
                        </button>
                        <button class="btn p-0 d-flex align-items-center" style="margin-left: 0.6rem;"
                          [disabled]="!$any(objet).manualValue || !$any(objet).measuredValue"
                          (click)="onValidate(j,$any(objet), true)">
                          <img src="assets/icon/restore.png" class="me-2" alt="Reset"/>
                          <span class="font-size-14 m-1">Reset</span>
                        </button>
                      </div>
                      @if ($any(objet).measuredValue) {
                        <span class="font-size-12">
                          {{ 'CONFIGURATION_DONNEES.MEASURED' | translate }}: {{ toAzimuthKpi($any(objet), $any(objet).measuredValue) }}
                          {{ replaceCurrencyPlaceholder(objet.referentielDonneeAnalyse.displayUnit) }}
                        </span>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
          @if (configeView) {
            <div class="d-flex justify-content-start align-items-center gap-3">
              <img class="mr-1"
                [src]="objet.isEnabled ? 'assets/icon/kpi-active.png' : 'assets/icon/kpi-inactive.png'" />
                <div class="descripition">{{ objet.isEnabled ? 'Active' : 'Inactive' }}</div>
              </div>
            }
            <div style="width: 6%">
              @if (estTir || configeView) {
                <div
                  class="d-flex flex-column justify-content-center align-items-center gap-2">
                  @if (configeView || objet.referentielDonneeAnalyse.typeSaisieKpi == 'InputText') {
                    <div>
                      <button *showIfHasRole="'access_all_kpi'"
                        class="btn background-button text-white border-radius-4 btn-sm"
                      (click)="onModifyKpiConfig(objet.referentielDonneeAnalyseId)">{{'PRODUCTS.DETAILS' | translate}}</button>
                    </div>
                  }
                  @if (!configeView && objet.referentielDonneeAnalyse.typeSaisieKpi == 'YesOrNo') {
                    <div>
                      <div class="switch custom-margin-left">
                        <input id="activate-{{objet.referentielDonneeAnalyseId}}" type="checkbox"
                          [checked]="$any(objet).finalValue === 'Oui'" (change)="onCheckboxChange($event, $any(objet))" disableIfNotHasRole="access_all_kpi" />
                          <label for="activate-{{objet.referentielDonneeAnalyseId}}"></label>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
